import { IConfigsType } from '../../types'

const fwWingstopDayPartReport: IConfigsType = {
  'fw_wingstop-day-part-report-a9d3f2e8': {
    '/:brand/day_part_report': {
      variables: [
        'date',
        {
          type: 'selectOptions',
          options: {
            farwestOrderModes: {
              defaultId: [['all_order_modes']],
              options: [
                {
                  id: 'all_order_modes',
                  parentId: 'root',
                  displayName: 'All Order Modes',
                },
                {
                  id: 'non_digital_root',
                  parentId: 'root',
                  displayName: 'Non-Digital',
                },
                {
                  id: 'non_digital',
                  parentId: 'non_digital_root',
                  displayName: 'All Non-Digital',
                },
                {
                  id: 'dine_in',
                  parentId: 'non_digital_root',
                  displayName: 'Dine-In',
                },
                {
                  id: 'walk_in_to_go',
                  parentId: 'non_digital_root',
                  displayName: 'Walk in - To Go',
                },
                {
                  id: 'call_in_to_go_call_center',
                  parentId: 'non_digital_root',
                  displayName: 'Call in - To Go / Call Center',
                },
                {
                  id: 'digital_root',
                  parentId: 'root',
                  displayName: 'Digital',
                },
                {
                  id: 'digital',
                  parentId: 'digital_root',
                  displayName: 'All Digital',
                },
                {
                  id: 'online',
                  parentId: 'digital_root',
                  displayName: 'Online',
                },
                {
                  id: 'dispatch_delivery',
                  parentId: 'digital_root',
                  displayName: 'Dispatch / Delivery',
                },
                {
                  id: 'third_party',
                  parentId: 'digital_root',
                  displayName: '3PD',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'fwWingstopCorporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: ['week', 'period', 'custom'],
        defaultType: 'week',
        isDailyCustom: true,
      },
      pageTitle: {
        type: 'title',
        title: 'Day Part Report',
        subTitle: [
          'R365 source (not an exact match to SSS, but directionally useful)',
        ],
      },
      filters: {
        type: 'grid',
        children: {
          types: {
            type: 'select',
            value: 'selectOptions.farwestOrderModes.value',
            onChange: 'selectOptions.farwestOrderModes.onChange',
            options: 'selectOptions.farwestOrderModes.options',
            label: 'Order Mode',
            width: `400px`,
          },
        },
      },
      download: {
        type: 'download-csv',
        api: 'fwWingstopDayPartOrderMode',
        fileName: 'getexpo-day-part-order-mode',
        message: 'Download as CSV',
        fields: [
          {
            key: 'dayPart',
            title:
              'Day Part (<%- selectOptions.farwestOrderModes.displayName[0].slice(-1)[0] %>)',
          },
          {
            key: 'valueForDateRange4InPast',
            title:
              '<%- date?.getInfo(-3)?.businessYear + " " + date?.getInfo(-3)?.displayName %> Actual',
            hide: '<%- _.isUndefined(date?.getInfo(-3)?.displayName) %>',
          },
          {
            key: 'yoyForDateRange4InPast',
            title:
              '<%- date?.getInfo(-3)?.businessYear + " " + date?.getInfo(-3)?.displayName %> YoY',
            hide: '<%- _.isUndefined(date?.getInfo(-3)?.displayName) %>',
          },
          {
            key: 'valueForDateRange3InPast',
            title:
              '<%- date?.getInfo(-2)?.businessYear + " " + date?.getInfo(-2)?.displayName %> Actual',
            hide: '<%- _.isUndefined(date?.getInfo(-2)?.displayName) %>',
          },
          {
            key: 'yoyForDateRange3InPast',
            title:
              '<%- date?.getInfo(-2)?.businessYear + " " + date?.getInfo(-2)?.displayName %> YoY',
            hide: '<%- _.isUndefined(date?.getInfo(-2)?.displayName) %>',
          },
          {
            key: 'valueForDateRange2InPast',
            title:
              '<%- date?.getInfo(-1)?.businessYear + " " + date?.getInfo(-1)?.displayName %> Actual',
            hide: '<%- _.isUndefined(date?.getInfo(-1)?.displayName) %>',
          },
          {
            key: 'yoyForDateRange2InPast',
            title:
              '<%- date?.getInfo(-1)?.businessYear + " " + date?.getInfo(-1)?.displayName %> YoY',
            hide: '<%- _.isUndefined(date?.getInfo(-1)?.displayName) %>',
          },
          {
            key: 'valueForDateRange1InPast',
            title:
              '<%- date?.getInfo(0)?.businessYear + " " + date?.getInfo(0)?.displayName %> Actual',
            hide: '<%- _.isUndefined(date?.getInfo(0)?.displayName) %>',
          },
          {
            key: 'yoyForDateRange1InPast',
            title:
              '<%- date?.getInfo(0)?.businessYear + " " + date?.getInfo(0)?.displayName %> YoY',
            hide: '<%- _.isUndefined(date?.getInfo(0)?.displayName) %>',
          },
        ],
      },
      salesTable: {
        type: 'table-v2',
        title: 'Sales $',
        api: 'fwWingstopDayPartSales',
        expanded: ['day_part_root'],
        columns: [
          {
            key: 'dayPart',
            title: 'Day Part',
            width: '300px',
          },
          {
            key: 'Past4',
            title:
              '<%- date?.getInfo(-3)?.businessYear + " " + date?.getInfo(-3)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-3)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange4InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange4InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange4InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past3',
            title:
              '<%- date?.getInfo(-2)?.businessYear + " " + date?.getInfo(-2)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-2)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange3InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange3InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange3InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past2',
            title:
              '<%- date?.getInfo(-1)?.businessYear + " " + date?.getInfo(-1)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-1)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange2InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange2InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange2InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past1',
            title:
              '<%- date?.getInfo(0)?.businessYear + " " + date?.getInfo(0)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(0)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange1InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange1InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange1InPastHeatMap %>',
                },
              },
            ],
          },
        ],
      },
      checksTable: {
        type: 'table-v2',
        title: 'Tickets #',
        api: 'fwWingstopDayPartChecks',
        expanded: ['day_part_root'],
        columns: [
          {
            key: 'dayPart',
            title: 'Day Part',
            width: '300px',
          },
          {
            key: 'Past4',
            title:
              '<%- date?.getInfo(-3)?.businessYear + " " + date?.getInfo(-3)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-3)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange4InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange4InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange4InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past3',
            title:
              '<%- date?.getInfo(-2)?.businessYear + " " + date?.getInfo(-2)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-2)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange3InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange3InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange3InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past2',
            title:
              '<%- date?.getInfo(-1)?.businessYear + " " + date?.getInfo(-1)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-1)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange2InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange2InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange2InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past1',
            title:
              '<%- date?.getInfo(0)?.businessYear + " " + date?.getInfo(0)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(0)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange1InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange1InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange1InPastHeatMap %>',
                },
              },
            ],
          },
        ],
      },
      checkAvgTable: {
        type: 'table-v2',
        title: 'Check Average',
        api: 'fwWingstopDayPartCheckAvg',
        columns: [
          {
            key: 'dayPart',
            title: 'Day Part',
            width: '300px',
          },
          {
            key: 'Past4',
            title:
              '<%- date?.getInfo(-3)?.businessYear + " " + date?.getInfo(-3)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-3)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange4InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange4InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange4InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past3',
            title:
              '<%- date?.getInfo(-2)?.businessYear + " " + date?.getInfo(-2)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-2)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange3InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange3InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange3InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past2',
            title:
              '<%- date?.getInfo(-1)?.businessYear + " " + date?.getInfo(-1)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(-1)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange2InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange2InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange2InPastHeatMap %>',
                },
              },
            ],
          },
          {
            key: 'Past1',
            title:
              '<%- date?.getInfo(0)?.businessYear + " " + date?.getInfo(0)?.displayName %>',
            hide: '<%- _.isUndefined(date?.getInfo(0)?.displayName) %>',
            align: 'center',
            children: [
              {
                key: 'valueForDateRange1InPast',
                title: 'Actual',
              },
              {
                key: 'yoyForDateRange1InPast',
                title: 'YOY',
                background: {
                  range: [100, 0],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values?.yoyForDateRange1InPastHeatMap %>',
                },
              },
            ],
          },
        ],
      },
    },
  },
}

export default fwWingstopDayPartReport
